import { render, staticRenderFns } from "./FmlTextArea.vue?vue&type=template&id=72483e53&"
import script from "./FmlTextArea.vue?vue&type=script&lang=js&"
export * from "./FmlTextArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports